import { Tab } from '../const';

/**
 * @function convertFromTabToGroupSubtab
 * @param { array } options
 * @param { string } groupId
 * @param { string } submenuId
 * @param { number } length
 * @returns { array }
 */
function convertFromTabToGroupSubtab(options, groupId, subtabId, length) {
	const results = options.map((option, index) => {
		return {
			[Tab.GroupId]: groupId,
			[Tab.Id]: option.id,
			[Tab.Name]: option.name,
			[Tab.Url]: option.url,
			[Tab.Desc]: option.desc,
			[Tab.Order]: String(length + index),
			[Tab.SubtabId]: subtabId,
			[Tab.Checked]: false,
		};
	});

	return results;
}

export default convertFromTabToGroupSubtab;
